import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userReducer from "./authRedux";
import walletReducer from "./walletRedux";
import productReducer from "./productRedux";
import profileReducer from "./profileRedux";
import genericReducer from "./genericRedux";
import orderReducer from "./orderRedux";
import cartReducer from "./cartRedux";
import genericLocations from "./genericLocationsRedux";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import transactionRedux from "./transactionRedux";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  cart: cartReducer,
  wallet: walletReducer,
  product: productReducer,
  profile: profileReducer,
  categories: genericReducer,
  transactions: transactionRedux,
  search_data: genericReducer,
  order_data: orderReducer,
  payout_data: orderReducer,
  countries: genericLocations,
  states: genericLocations,
  cities: genericLocations,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export let persistor = persistStore(store);
